import { Dialog, DialogProps } from "../../core/components/dialog.js";
import { Grid } from "../../core/components/grid.js";
import { Config } from "../../core/config/config.js";
import { Helper } from "../../core/util/helper.js";
import { ResourcePlanningSchedulerEventViewModel } from "../resourcePlanningScheduler.js";
import { DeletingExecutionAssignmentPreview } from "../../resourcePlanningDialogs/resourcePlanningDeletionDialog.js";
import GridOptions = kendo.ui.GridOptions;
import GridColumn = kendo.ui.GridColumn;
import React from "react";
import ReactDOM from "react-dom";

export const OpenEventInfoDialog = (events: ScheduleEventToBeDeletedViewModel[], title: string) => {
    return new Promise<boolean>((resolve) => {
        const targetElement = $("<div>");
        $("body").append(targetElement);
        const root = ReactDOM["createRoot"](targetElement[0]);

        const removeDialog = () => {
            root.unmount(targetElement[0]);
            targetElement[0].remove();
        }

        const props: any = {
            onOk: () => {
                resolve(true)
                removeDialog();
            },
            onCancel: () => {
                resolve(false);
                removeDialog();
            },
            events: events,
            title: title
        }
        root.render(<EventInfoDialog {...props} />);
    })
}

export interface ScheduleEventToBeDeletedViewModel extends ResourcePlanningSchedulerEventViewModel {
    Preview?: DeletingExecutionAssignmentPreview
    IsDeletable: boolean;
}

interface EventInfoDialogProps {
    events: ScheduleEventToBeDeletedViewModel[];
    title: string;
    onOk: () => void;
    onCancel: () => void;
}

class EventInfoDialog extends React.Component<EventInfoDialogProps, {}>{
    private _dialogProps: DialogProps = {
        title: this.props.title,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOk();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.props.onCancel();
        },
        width: "90%"
    };

    private gridOptions: GridOptions = {
        sortable: true,
        pageable: false,
        groupable: false,
        filterable: false,
        selectable: true,
        resizable: true,
        scrollable: true,
        columns: [
            {
                title: Helper.getTranslation("Field.Einsatz.projnr"),
                field: "Projnr",
                template: `#let url = '${Config.baseUrl}ResourcePlanning/Edit?projnr=' + data.Projnr + '&pindex=' + data.Pindex;#<a target="_blank" href="#=url#">#=data.Projnr#/#=data.Pindex#</a>`,
                width: 200
            },
            {
                title: Helper.getTranslation("Field.Einsatz.Bemerkung"),
                field: "Title",
                width: 200
            },
            {
                title: Helper.getTranslation("Field.Ressource.name"),
                field: "ResourceName",
                template: "#let text = data.ResourceName;let arr = data.ResourceId.split('|');text += ' (' + arr[1] + ')';#<div>#=text#</div>",
                width: 140
            },
            {
                title: Helper.getTranslation("Field.Adresse.adrname"),
                field: "AdrName",
                width: 180
            },
            {
                title: Helper.getTranslation("Field.Einsatz.startist"),
                field: "Start",
                template: "#= kendo.toString(kendo.parseDate(Start), 'g') #",
                width: 140
            },
            {
                title: Helper.getTranslation("Field.Einsatz.endeist"),
                field: "End",
                template: "#= kendo.toString(kendo.parseDate(End), 'g') #",
                width: 140
            },
        ]
    };

    private getGridOptions = () => {

        let selectionColumnVisible = this.props.events.find(e => !e.IsDeletable) != null;
        let selectionColumn: GridColumn = {
            title: "",
            field: "IsDeletable",
            width: 35,
            hidden: !selectionColumnVisible,
            template: "#if(data.IsDeletable) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"
        };
        let firstColumn: GridColumn[] = [];
        // if (selectionColumnVisible)
        firstColumn.push(selectionColumn);

        let columns = [...firstColumn, ...this.gridOptions.columns];

        let cycleColumn: GridColumn = {
            title: Helper.getTranslation("WebCRM.Tasks.RecurringTask.IntervalCycle"),
            width: 280,
            hidden: !selectionColumnVisible,
            field: "Preview.TaskExecutionInfo.Title",
            template: "# let executionInfo = data.Preview != null ? data.Preview.TaskExecutionInfo : null; #<div>#if (executionInfo != null) {#<a href='#=Innosoft.Config.baseUrl#RecurringTask/Edit?id=#=executionInfo.TaskId#' target='_blank'>#=executionInfo.TaskNo#</a>: #=executionInfo.Title# #}#</div>"
        }

        // if(selectionColumnVisible)
        columns.push(cycleColumn);

        let gridOptions: GridOptions = { ...this.gridOptions, columns: columns };
        return gridOptions;
    }

    constructor(props: EventInfoDialogProps) {
        super(props);
        this.state = {
        };
    }

    private getInMobileFieldServiceWarning = () => {
        let events = this.props.events.filter(x => Helper.hasValue(x.Datenpaket) || x.IsSendToMobileApp);
        if (events.length > 0)
            return <div style={{ color: "#ff0000" }} >{Helper.getTranslation("Einsatz.AlreadySendMobFieldServiceMultiple")}</div>
        else
            return null;
    }

    private createGrid = () => {
        return <Grid data={this.props.events} options={this.getGridOptions()} id={"eventInfoGrid"} />;
    }

    componentDidMount() {
        let atLeastOneDeletable = this.props.events.find(e => e.IsDeletable);
        if (atLeastOneDeletable != null)
            return;

        let elems = this.dialogRef.rootDiv.parentElement.getElementsByClassName("k-button-solid-primary");
        if (elems.length > 0)
            elems[0].classList.add("k-disabled");
    }

    private dialogRef: Dialog;

    render() {
        let atLeastOneNonDeletable = this.props.events.find(e => !e.IsDeletable);

        let cycleExecutionAssignmentsWarning = null;
        if (atLeastOneNonDeletable != null)
            cycleExecutionAssignmentsWarning = <div style={{ color: "#ff0000" }} >{Helper.getTranslation("Einsatz.ExecutionAssignment.MultiDelete.SomeExecutionAssignmentsWarning")}</div>

        return (<>
            <Dialog {...this._dialogProps} open={true} ref={(e) => { this.dialogRef = e; }}>
                {cycleExecutionAssignmentsWarning}
                {this.getInMobileFieldServiceWarning()}
                {this.createGrid()}
            </Dialog>
        </>)
    }
}